import { InstoreServicesRoutes } from 'router/instore-services-routes';

export function hasInStoreServiceWithShop(url: string) {
	// Удаляем начальный и конечный слэши для единообразия
	const normalizedUrl = url.replace(/^\/|\/$/g, '');

	return InstoreServicesRoutes.some(route => {
		const normalizedRoute = route.replace(/^\/|\/$/g, '');

		// Проверяем только маршруты с `:shop`
		if (normalizedRoute.includes(':shop')) {
			// Заменяем `:shop` на regex для захвата любого сегмента
			const routePattern = normalizedRoute.replace(':shop', '([^/]+)');
			const regex = new RegExp(`^${routePattern}$`);
			return regex.test(normalizedUrl);
		}

		return false; // Игнорируем маршруты без `:shop`
	});
}
